(function () {
  'use strict';

  function initializeSlider(root) {
    if (root.dataset.ugc2Ready === 'true') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ugc2-slide]'));
    if (!slides.length) return;
    root.dataset.ugc2Ready = 'true';

    var previousButton = root.querySelector('[data-ugc2-prev]');
    var nextButton = root.querySelector('[data-ugc2-next]');
    var playButton = root.querySelector('[data-ugc2-play]');
    var soundButton = root.querySelector('[data-ugc2-sound]');
    var counter = root.querySelector('[data-ugc2-counter]');
    var current = 0;
    var inView = false;
    var manuallyPaused = false;
    var soundEnabled = false;

    function currentVideo() {
      return slides[current].querySelector('video');
    }
    function updateControls() {
      var playing = !currentVideo().paused;
      playButton.setAttribute('aria-label', playing ? 'Video pausieren' : 'Video abspielen');
      playButton.querySelector('[data-ugc2-pause-icon]').hidden = !playing;
      playButton.querySelector('[data-ugc2-play-icon]').hidden = playing;
      soundButton.setAttribute('aria-label', soundEnabled ? 'Ton ausschalten' : 'Ton einschalten');
      soundButton.querySelector('[data-ugc2-muted-icon]').hidden = soundEnabled;
      soundButton.querySelector('[data-ugc2-unmuted-icon]').hidden = !soundEnabled;
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
    }
    function pauseAll() {
      slides.forEach(function (slide) { slide.querySelector('video').pause(); });
      updateControls();
    }
    function playVisible() {
      if (!inView || document.hidden || manuallyPaused) return;
      var video = currentVideo();
      video.muted = !soundEnabled;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () { updateControls(); });
      }
      updateControls();
    }
    function goTo(index) {
      if (slides.length <= 1) return;
      pauseAll();
      slides[current].hidden = true;
      current = (index + slides.length) % slides.length;
      slides[current].hidden = false;
      currentVideo().muted = !soundEnabled;
      manuallyPaused = false;
      updateControls();
      playVisible();
    }
    function togglePlay() {
      var video = currentVideo();
      if (video.paused) {
        manuallyPaused = false;
        playVisible();
      } else {
        manuallyPaused = true;
        video.pause();
      }
      updateControls();
    }

    slides.forEach(function (slide, index) {
      var video = slide.querySelector('video');
      video.muted = true;
      video.playsInline = true;
      if (index !== 0) video.pause();
      video.addEventListener('play', updateControls);
      video.addEventListener('pause', updateControls);
      video.addEventListener('click', function () {
        if (index === current) togglePlay();
      });
    });
    if (previousButton) previousButton.addEventListener('click', function () { goTo(current - 1); });
    if (nextButton) nextButton.addEventListener('click', function () { goTo(current + 1); });
    playButton.addEventListener('click', togglePlay);
    soundButton.addEventListener('click', function () {
      soundEnabled = !soundEnabled;
      currentVideo().muted = !soundEnabled;
      updateControls();
      if (currentVideo().paused) {
        manuallyPaused = false;
        playVisible();
      }
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' && previousButton) {
        event.preventDefault();
        goTo(current - 1);
      } else if (event.key === 'ArrowRight' && nextButton) {
        event.preventDefault();
        goTo(current + 1);
      }
    });
    var startX = 0;
    var startY = 0;
    var viewport = root.querySelector('.ugc2__viewport');
    viewport.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    viewport.addEventListener('touchend', function (event) {
      if (!event.changedTouches.length) return;
      var deltaX = event.changedTouches[0].clientX - startX;
      var deltaY = event.changedTouches[0].clientY - startY;
      if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.3) {
        goTo(current + (deltaX < 0 ? 1 : -1));
      }
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pauseAll();
      else playVisible();
    });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
        if (inView) playVisible();
        else pauseAll();
      }, { threshold: [0, 0.15, 0.5] });
      observer.observe(root);
    } else {
      inView = true;
      playVisible();
    }
    updateControls();
  }
  function initializeAll() {
    document.querySelectorAll('[data-ugc2-slider]').forEach(initializeSlider);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
